import { createContext, useEffect, useState } from "react"


export const InterfaceContext = createContext();

const InterfaceContextProvider = ({children}) => {
    const [responsiveMenuVisible, setResponsiveMenuVisible] = useState(false);
    const [responsiveMenuOpen, setResponsiveMenuOpen] = useState(false);

    useEffect(() => {
        const update = () => setResponsiveMenuVisible(window.innerWidth < 1200);
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    const openResponsiveMenu = () => {
        setResponsiveMenuOpen(true);
    }
    const closeResponsiveMenu = () => {
        setResponsiveMenuOpen(false);
    }
    return (
        <InterfaceContext.Provider value={{
            responsiveMenuVisible,
            responsiveMenuOpen,
            openResponsiveMenu,
            closeResponsiveMenu}} >
            {children}
        </InterfaceContext.Provider>
    )
}

export default InterfaceContextProvider;
